import React from "react";
import Context from "../../../Context";
import EssenceFiles from "../../Essence/EssenceFiles";
import BsModal from "../BsModal";
export default class FilesModalButton extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      modalShow: false,
      pending: false,
      files: [],
    };
  }
  componentDidMount() {
    this.load();
  }
  componentDidUpdate(prevProps) {
    if (prevProps.objectId !== this.props.objectId) {
      this.load();
    }
  }
  load = async () => {
    if (this.props.objectId) {
      this.setState({ pending: true });

      let files = await this.context.api.q("/object/file", {
        id: this.props.objectId,
      });

      this.setState({
        files: Array.isArray(files) ? files : [],
        pending: false,
      });
    }
  };

  onAfterSave = (result = {}) => {
    this.load();
  };

  modalShow = () => {
    this.setState({ modalShow: true });
  };
  modalClose = () => {
    this.setState({ modalShow: false });
  };

  render() {
    const { objectId } = this.props;
    const { pending, files } = this.state;
    let btnClasses = this.props.className || "btn btn-white btn-icon";
    let extraClasses = "";

    if (pending) extraClasses = "opacity-50";

    return (
      <>
        <BsModal show={this.state.modalShow} onClose={this.modalClose}>
          <EssenceFiles
            essence=""
            onAfterSave={this.onAfterSave}
            id={objectId}
            key={objectId}
            denyDelete
            showUser
          />
        </BsModal>
        <div
          onClick={this.modalShow}
          className={`${btnClasses} ${extraClasses}`}
          title="Файлы"
        >
          {this.props.children}
          {!pending && files.length > 0 && (
            <span className="label label-secondary">{files.length}</span>
          )}
        </div>
      </>
    );
  }
}
